import CampusTierLanding from "@/components/site/CampusTierLanding";
export default function CampusTeamPage() {
  return <CampusTierLanding tier="team" />;
}
